import { Component } from '@theme/component';
class MtVideos extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.querySelectorAll('article').forEach(article => {
      const video = article.querySelector('video');
      const button = article.querySelector('[data-video-play]');
      if (!video || !button) return;
      button.hidden = false;
      button.addEventListener('click', () => { video.play().catch(() => { button.hidden = false; }); }, { signal });
      video.addEventListener('play', () => { button.hidden = true; }, { signal });
      video.addEventListener('pause', () => { button.hidden = false; }, { signal });
      video.addEventListener('ended', () => { button.hidden = false; }, { signal });
    });
    this.addEventListener('play', event => {
      document.querySelectorAll('mt-videos video').forEach(video => { if (video !== event.target) video.pause(); });
    }, { capture: true, signal: this.abort.signal });
  }
  disconnectedCallback() { super.disconnectedCallback(); this.abort?.abort(); }
}
if (!customElements.get('mt-videos')) customElements.define('mt-videos', MtVideos);
